<template>
  <div class="input-group-append">
    <button
      :disabled="disabled"
      @click.prevent="click($event)"
      class="button btn btn-primary edit-button"
      type="button"
    >
      {{ value }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ModalInputActionButton",
  components: {},
  props: {
    value: {
      required: true,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    click($event) {
      this.$emit("click", $event);
    },
  },
};
</script>

<style scoped>
.edit-button {
  background-color: #ced4da;
  height: 100%;
  border: none;
  border-radius: 2px;
}

.input-group-append {
  margin-left: -1px;
}
.input-group-append,
.input-group-prepend {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.button {
  position: absolute;
  right: 6px;
  height: 38px;
  width: 32px;
  top: -3px;
  opacity: 1 !important;
  padding: 0px;
  color: rgb(100, 95, 95);
}

.button:focus {
  background-color: #ced4da !important;
  border: 1px solid #aeaeae !important;
  color: #666 !important;
  box-shadow: 0 0 0 0.2rem transparent;
  cursor: pointer;
}

.button:hover {
  background-color: #ced4da;
  border: 1px solid #aeaeae !important;
  color: #666 !important;
  box-shadow: 0 0 0 0.2rem #aeaeae !important;
}

.button:active {
  background-color: #ced4da;
  border: 1px solid #aeaeae !important;
  color: #666 !important;
  box-shadow: 0 0 0 0.2rem #aeaeae !important;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ModalInputActionButton.vue